import { apiAuth, apiResponseType } from ".";

export const getSectorsData = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `sectors?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}${
      name ? `&name=${encodeURIComponent(name)}` : ""
    }`
  );

export const registerSectorsData = (data) =>
  apiAuth.post("/sectors/store", data) as apiResponseType;

export const deleteSectorsData = (uuid: string) =>
  apiAuth.delete(`sectors/${uuid}/destroy`) as apiResponseType;

export const updateSectorsData = (uuid: string, data) =>
  apiAuth.post(`sectors/${uuid}/update`, data) as apiResponseType;

export const getShowSectors = (uuid: string) =>
  apiAuth.get(`sectors/${uuid}/show`) as apiResponseType;

export const searchSectorsData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `sectors?name=${params.name}${
      params.unity_id ? `&unity_id=${params.unity_id}` : ""
    }`
  );

export const setStatusSectors = (uuid: string) =>
  apiAuth.put(`sectors/${uuid}/toggle-status`) as apiResponseType;

export const getSelectSectors = (unity_id?: number | string) =>
  apiAuth.get(
    `sectors/select${unity_id ? `?unity_id=${unity_id}` : ""}`
  ) as apiResponseType;
